<template lang="pug">
  b-container(fluid, style="width:100%;height:100%;")
    .d-flex.align-items-center.justify-content-center.flex-column.h-100
      b-img.mb-3(src="@/assets/Loading-AN.gif", fluid, :class="$breakpoint.mdUp ? 'w-25' : 'w-75'")
      p.text-primary {{ message }}
      b-progress(:value="elapsed_time", animated, variant="primary", :class="$breakpoint.mdUp ? 'w-25' : 'w-100'")
</template>

<script>
import { EventBus } from '@/helpers/eventBus'

export default {
  data () {
    return {
      interval: null,
      elapsed_time: 0,
      message: 'Cargando configuración...'
    }
  },
  methods: {
    stopTimer () {
      clearInterval(this.interval)
    },
    completeLoad () {
      this.message = '¡Todo listo!'
      this.$nextTick(() => {
        this.elapsed_time = 100
        setTimeout(function () {
          EventBus.$emit('plugins:check')
        }, 1000);
      })
    },
    showAlert() {
      if (document.domain !== 'app.nerds.ai') {
        setTimeout(() => {
          const tag = this.$createElement

          this.$message.info({
            duration: 0,
            showClose: true,
            message: tag('p', { style: 'width: 1100px;' }, [
              tag('span', null, 'A partir del 1 de Mayo, la url de la plataforma cambiará a: '),
              tag('a', { attrs: { href: 'https://app.nerds.ai' }, style: 'color: inherit; margin-top: 20px; text-decoration: none; cursor:pointer; background-color: #ccdcff; padding: 0px 2px; border-radius: 5px; font-size: 16px;' }, 'https://app.nerds.ai '),
              tag('span', null, 'por lo que https://socialkit.botlers.io te redirigirá al nuevo dominio.')
            ])
          })
        }, 500)
      }
    }
  },
  created () {
    EventBus.$emit('plugins:check')
    this.stopTimer()

    this.interval = setInterval(() => {
      if (this.elapsed_time >= 95) {
        this.stopTimer()
        this.message = 'Esto está tardando más de lo normal...'
      } else if (this.elapsed_time >= 70) {
        this.elapsed_time += Math.floor((Math.random() * 5) + 1)
      } else {
        if (Math.floor(Math.random() * 2))
          this.elapsed_time += Math.floor((Math.random() * 20) + 1)
      }
    }, 1000)

    EventBus.$on('plugins:loaded', () => {
      this.stopTimer()
      this.completeLoad()
    })
  },
  beforeDestroy () {
    this.stopTimer()
    EventBus.$off('plugins:loaded')
  }
}
</script>

<style lang="scss" scoped>
</style>
